module.exports = __webpack_public_path__ + "img/OBTURADO_RECURRENTE.png";